var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotVisible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_962_4092)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9.00027C21.3862 10.7739 19.836 12.232 17.9976 13.2353C16.1592 14.2385 14.0942 14.7533 12 14.7303C9.90581 14.7533 7.84076 14.2385 6.00237 13.2353C4.16398 12.232 2.61376 10.7739 1.5 9.00027C2.61376 7.22666 4.16398 5.7685 6.00237 4.76526C7.84076 3.76203 9.90581 3.24728 12 3.27027C14.0942 3.24728 16.1592 3.76203 17.9976 4.76526C19.836 5.7685 21.3862 7.22666 22.5 9.00027Z",
    stroke: "#B2C3D7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.7295C15.1646 14.7295 17.73 12.1641 17.73 8.99953C17.73 5.83494 15.1646 3.26953 12 3.26953C8.83543 3.26953 6.27002 5.83494 6.27002 8.99953C6.27002 12.1641 8.83543 14.7295 12 14.7295Z",
    stroke: "#B2C3D7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 10.9098C13.0547 10.9098 13.9098 10.0547 13.9098 8.99984C13.9098 7.94498 13.0547 7.08984 11.9998 7.08984C10.945 7.08984 10.0898 7.94498 10.0898 8.99984C10.0898 10.0547 10.945 10.9098 11.9998 10.9098Z",
    stroke: "#B2C3D7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 9.00027C21.3862 10.7739 19.836 12.232 17.9976 13.2353C16.1592 14.2385 14.0942 14.7533 12 14.7303C9.90581 14.7533 7.84076 14.2385 6.00237 13.2353C4.16398 12.232 2.61376 10.7739 1.5 9.00027C2.61376 7.22666 4.16398 5.7685 6.00237 4.76526C7.84076 3.76203 9.90581 3.24728 12 3.27027C14.0942 3.24728 16.1592 3.76203 17.9976 4.76526C19.836 5.7685 21.3862 7.22666 22.5 9.00027Z",
    stroke: "#B2C3D7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.7295C15.1646 14.7295 17.73 12.1641 17.73 8.99953C17.73 5.83494 15.1646 3.26953 12 3.26953C8.83543 3.26953 6.27002 5.83494 6.27002 8.99953C6.27002 12.1641 8.83543 14.7295 12 14.7295Z",
    stroke: "#B2C3D7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 10.9098C13.0547 10.9098 13.9098 10.0547 13.9098 8.99984C13.9098 7.94498 13.0547 7.08984 11.9998 7.08984C10.945 7.08984 10.0898 7.94498 10.0898 8.99984C10.0898 10.0547 10.945 10.9098 11.9998 10.9098Z",
    stroke: "#B2C3D7",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 1L4 17",
    stroke: "#B2C3D7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_962_4092"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVisible);
export default __webpack_public_path__ + "static/media/not-visible.6a3c4bc76a10f8a58f6c2cfb7bf19ca7.svg";
export { ForwardRef as ReactComponent };